<h1 class="titulo-principal">Ingresa tus datos y estarás a un <br class="d-none-mobile"> paso de dar de alta tu comercio</h1>
<p class="descripcion-principal">Para ahorrarte trabajo, ya tenemos algunos datos por sistema, ahora sólo <br> completa los faltantes.</p>


<mat-accordion>
  <ng-container *ngIf="isPersonaNatural; else personaJuridica">

    <app-datos-personales-ci *ngIf="!isRetoma;else retoma" [showInfoMessage]="showInfoMessage" [showCantidadCampos]="showCantidadCampos" (paso1Ok)="paso1Ok()"></app-datos-personales-ci>

    <ng-template #retoma>
      <app-datos-personales [showInfoMessage]="showInfoMessage" [showCantidadCampos]="showCantidadCampos" (paso1Ok)="paso1Ok()"></app-datos-personales>
    </ng-template>

    <app-datos-comercio [showInfoMessage]="showInfoMessage" [showCantidadCampos]="showCantidadCampos" (paso2Ok)="paso2Ok()"></app-datos-comercio>

    <app-configuracion-producto [showCantidadCampos]="showCantidadCampos" *ngIf="flujos.configuracionProducto.visible" (paso3Ok)="paso3Ok()"></app-configuracion-producto>

    <app-datos-adjuntos [showCantidadCampos]="showCantidadCampos" *ngIf="flujos.datosAdjuntos.visible" (paso5Ok)="paso5Ok()"></app-datos-adjuntos>

    <app-cuenta-bancaria [showCantidadCampos]="showCantidadCampos" (nextStep)="onNextStepClick($event)"></app-cuenta-bancaria>

  </ng-container>

  <ng-template #personaJuridica>

    <app-datos-empresa [showInfoMessage]="showInfoMessage" [showCantidadCampos]="showCantidadCampos" (paso1Ok)="paso1Ok()"></app-datos-empresa>

    <app-datos-socio [showInfoMessage]="showInfoMessage" [showCantidadCampos]="showCantidadCampos" (paso2Ok)="paso2Ok()"></app-datos-socio>

    <app-configuracion-producto-pj [showCantidadCampos]="showCantidadCampos" *ngIf="flujos.configuracionProducto.visible" (paso3Ok)="paso3Ok()"></app-configuracion-producto-pj>

    <app-declaracion-jurada (paso4Ok)="paso4Ok()"></app-declaracion-jurada>

    <app-datos-adjuntos [showCantidadCampos]="showCantidadCampos" *ngIf="flujos.datosAdjuntos.visible" (paso5Ok)="paso5Ok()"></app-datos-adjuntos>

    <app-cuenta-bancaria-pj (nextStep)="onNextStepClick($event)"></app-cuenta-bancaria-pj>

  </ng-template>
</mat-accordion>
